module.exports = __webpack_public_path__ + "media/images/favicon-9812d5683e7a43df7a4783fcbd668337.ico";